import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=79c40e75&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=79c40e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c40e75",
  null
  
)

export default component.exports